import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {IonicModule, IonicRouteStrategy, IonRouterOutlet} from '@ionic/angular';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {ComponentsModule} from './components/components.module';
import {MapService} from './services/map.service';

import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {LogicService} from './services/logic.service';

import {IonicStorageModule} from '@ionic/storage-angular';
import {LoadingService} from './services/loading.service';
import {NotificationService} from './services/notification.service';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';

import {InternalStorage, SDKBrowserModule, StorageBrowser} from '../Api';
import {CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import {AuthInterceptor} from './helper/httpconfig.interceptor';
import {SwiperModule} from 'swiper/angular';
import { InAppPurchase2 } from '@ionic-native/in-app-purchase-2/ngx';

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}


@NgModule({ declarations: [
        AppComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    bootstrap: [AppComponent], imports: [CommonModule,
        BrowserModule,
        FormsModule,
        IonicModule.forRoot({
            swipeBackEnabled: false,
            animated: false,
            statusTap: false
        }),
        AppRoutingModule,
        ComponentsModule,
        SwiperModule,
        // IonicStorageModule.forRoot({
        //     name: '__mydb',
        //     driverOrder: ['indexeddb', 'sqlite', 'websql']
        // }),
        IonicStorageModule.forRoot(),
        SDKBrowserModule.forRoot({
            provide: InternalStorage,
            useClass: StorageBrowser
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        IonicModule.forRoot()], providers: [
        MapService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        LogicService,
        LoadingService,
        NotificationService,
        InAppPurchase2,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        {
            provide: IonRouterOutlet,
            useValue: {
                swipeGesture: false,
                swipeBackEnabled: false,
                animated: false
            }
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
